import React, { useState, useRef } from 'react';

import { Box, Button, ModalForm } from '../../core-ui';
import MarketSelectorFormView from '../FormBuilder/FormElements/MarketSelectorElement/MarketSelectorFormView';
import { MarketDates } from '../../types/shared/Vendor';

import { GetRecipients_season_markets as Market } from './__generated__/GetRecipients';

type Props = {
  markets: Array<Market>;
  initialSelection: MarketDates;
  onSubmit: (value: MarketDates) => void;
};

export default function MarketDatesFilterModal(props: Props) {
  const { markets, initialSelection, onSubmit } = props;
  const [isOpen, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const selection = useRef<MarketDates>({});

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
        }}
      >
        {t('Markets & Dates')}
      </Button>
      <ModalForm
        title={t('Choose Markets')}
        isOpen={isOpen}
        contentProps={{ w: 'container.md', maxW: '100vw' }}
        submitButtonText={t('Set Filter')}
        onSubmit={() => {
          onSubmit(selection.current);
          onClose();
        }}
        additionalButtons={[
          {
            text: t('Clear Filter'),
            onClick: () => {
              onSubmit({});
              onClose();
            },
          },
        ]}
        showCancelButton={false}
        onClose={onClose}
      >
        <Box>
          {/* TODO: Rewrite the MarketSelectorFormView in Chakra */}
          <MarketSelectorFormView
            definition={{ type: 'MarketSelectorElement', id: '' }}
            markets={markets.map((market) => ({
              id: market.id,
              // TODO: Find a way to remove the need for `season` field
              season: '',
              name: market.name,
              description: market.description,
              dates: market.dates,
              num_spots: market.numSpots,
              hidden: market.hidden,
              createdAt: market.createdAt,
              updatedAt: market.updatedAt,
            }))}
            handleMarketDateSelect={(selectedMarketDates) => {
              selection.current = selectedMarketDates;
            }}
            value={initialSelection}
          />
        </Box>
      </ModalForm>
    </>
  );
}
